import React, { useContext } from "react";
import { Link } from "react-router-dom";
import Seo from "./Head";
import { CartContext } from "../context/CartContext";

const Tienda = () => {
  const { dbCategories = [] } = useContext(CartContext);

  // Filtramos "Talleres" para no mostrarlo en esta sección
  const filteredCategories = dbCategories.filter(
    (cat) => cat.nombre.toLowerCase() !== "talleres",
  );

  // Función auxiliar para generar el slug de forma idéntica al backend
  // por si el objeto 'cat' no trae el campo 'slug' todavía
  const getSlug = (cat) => {
    if (cat.slug) return cat.slug;
    return cat.nombre
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // Quita tildes
      .replace(/[^a-z0-9]+/g, "-") // Cambia espacios y raros por guiones
      .replace(/^-+|-+$/g, ""); // Limpia guiones al inicio y final
  };

  return (
    <>
      <Seo
        title="Tienda Espacio Analógico"
        description="Rollos, papeles, libros, talleres"
        image={`${window.location.origin}/static/media/LogoNuevo.c219d0bf4f0348ebfdc3.png`}
        pathSlug={window.location.href}
      />

      <div className="container-fluid px-1 px-md-5 py-1 py-md-3 ">
        <div className="item row justify-content-center categorias-wrapper">
          {filteredCategories.map((cat) => (
            <div
              key={cat.id}
              className="col-6 p-1 col-sm-2 col-md-2 ps-2 pe-2 mb-4"
            >
              <div className="card">
                <div className="talleres">
                  <Link
                    to={`/tienda/${getSlug(cat)}`}
                    className="text-decoration-none"
                  >
                    <div className="cajaDeCajas">
                      <div className="imgMedida caja">
                        <div className="prueba img-container">
                          <img
                            src={
                              cat.imagen ||
                              "https://via.placeholder.com/400x600?text=Sin+Imagen"
                            }
                            alt={cat.nombre}
                            className="img-fluid"
                          />
                        </div>
                      </div>

                      <h4 className="textoCat text-center negrita">
                        {cat.nombre}
                      </h4>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Tienda;
